import ConnectioPointsTable from "../Components/Connections/ConnectionPointsTable"
import { useGetAllItemsAndLayoutsQuery } from '../Slices/roomNateApis'
import { useGetAllConnectionPointsOptionsQuery, useGetAllConnectionPointsQuery } from '../Slices/roomNateConstantApis'

const AddConnection = () => {
  const { data: connectionPointsOptionsData } = useGetAllConnectionPointsOptionsQuery()

  const { data: connectionPointsData } = useGetAllConnectionPointsQuery()
  const { data: FetchItems } = useGetAllItemsAndLayoutsQuery()

  return (
    <>
      <ConnectioPointsTable FetchItems={FetchItems} connectionPointsData={connectionPointsData} connectionPointsOptionsData={connectionPointsOptionsData} />
    </>
  )
}

export default AddConnection